'use client';

import { StoryblokStory } from 'storyblok-generate-ts';
import { PostStoryblok } from '@/types/types-storyblok';
import { useEffect, useState } from 'react';
import { PostCard } from './postsList/postCard';
import { getCmsStories } from '@/storyblok/client';
import { Pagination } from './postsList/pagination';
import { useSearchParams } from 'next/navigation';

export const PostsList = ({
  posts: initialPostsData,
  totalPostsCount,
  postsFilterQuery,
  searchTerm,
}: {
  posts: StoryblokStory<PostStoryblok>[];
  postsFilterQuery: Record<string, any>;
  totalPostsCount: number;
  searchTerm?: string;
}) => {
  const searchParams = useSearchParams();
  let page = 1;
  if (searchParams.has('page')) {
    const searchParamPage = searchParams.get('page') as string;
    const intVal = parseInt(searchParamPage);
    if (!isNaN(intVal)) {
      page = intVal;
    }
  }
  const [posts, setPosts] = useState(initialPostsData);
  const [loading, setLoading] = useState(false);
  const nOfPages = Math.ceil(totalPostsCount / 9);

  const onPageChange = async (page: number) => {
    setLoading(true);
    try {
      const {
        data: { stories },
      } = await getCmsStories<PostStoryblok>({
        page,
        filter_query: postsFilterQuery,
        per_page: 9,
        starts_with: 'guide/',
        sort_by: 'first_published_at:desc',
        resolve_relations: ['post.categories'],
        search_term: searchTerm,
      });
      setPosts(stories);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onPageChange(page);
    // having onPageChange as a dependency would cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <>
      <ul className="mt-14 flex flex-col gap-8 md:gap-x-12 md:gap-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:px-20 xl:mx-auto xl:px-0 xl:max-w-screen-xl">
        {posts.map(post => (
          <PostCard key={post.id} post={post} />
        ))}
      </ul>
      <Pagination disabled={loading} currentPage={page} numberOfPages={nOfPages} />
    </>
  );
};
